import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/SIPPAG-dark.svg'
import _imports_1 from '@/assets/SEI_dark.png'
import _imports_2 from '@/assets/siape-dark.png'
import _imports_3 from '@/assets/SIPEC.png'
import _imports_4 from '@/assets/suape.png'


const _withScopeId = n => (_pushScopeId("data-v-97dd22ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 overflow-hidden" }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-center align-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "SIPPAG web Logo",
    class: "mb-1",
    src: _imports_0,
    style: {"width":"10rem","height":"3.5rem"}
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"15px"} }, [
  /*#__PURE__*/_createTextVNode(" Sistema Integrado de Protocolo, Pagamento e Gestão "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Experiência e software sob medida através de serviços inovadores que facilitam a vida dos servidores públicos. ")
], -1))
const _hoisted_5 = {
  class: "py-0",
  id: "sippag"
}
const _hoisted_6 = { class: "w-100 h-100" }
const _hoisted_7 = { class: "d-flex flex-row align-center justify-center fill-height" }
const _hoisted_8 = {
  class: "d-flex flex-column justify-center align-center",
  style: {"min-width":"400px"}
}
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-5 d-flex justify-center align-center flex-column" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "text-h6" }, "O que o SIPPAG é capaz de fazer?"),
  /*#__PURE__*/_createElementVNode("label", { class: "w-75 ali text-center text-subtitle-1" }, " Com variados módulos de cálculos, o sistema é capaz de acelerar os processos, e por serem automatizados, reduzem as possibilidades de erros. ")
], -1))
const _hoisted_11 = { class: "d-flex flex-wrap justify-center" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-5 d-flex justify-center align-center flex-column" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "text-h6" }, "Portarias"),
  /*#__PURE__*/_createElementVNode("label", { class: "w-75 ali text-center text-subtitle-1" }, " Com modelos padronizados, o sistema é capaz de agilizar a criação de portarias, permitindo gerar automaticamente esses documentos a partir de assuntos pré-definidos. ")
], -1))
const _hoisted_14 = { class: "d-flex flex-row justify-around" }
const _hoisted_15 = { class: "mt-10" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-center align-center flex-column mb-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "text-h6" }, "Módulos integrados"),
  /*#__PURE__*/_createElementVNode("label", { class: "w-75 ali text-center text-subtitle-1" }, [
    /*#__PURE__*/_createTextVNode(" O SIPPAG possibilita integração com outros serviços de necessidade da sua Instituição, para trazer uma experiência ainda mais completa. Alguns exemplos de sistema que já fazem integração com o SIPPAG são "),
    /*#__PURE__*/_createElementVNode("strong", null, "SEI!"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("strong", null, "SIAPE"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("strong", null, "SIPEC"),
    /*#__PURE__*/_createTextVNode(" e "),
    /*#__PURE__*/_createElementVNode("strong", null, "SUAP"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1))
const _hoisted_17 = { class: "carrosel" }
const _hoisted_18 = { class: "d-flex flex-row justify-center" }
const _hoisted_19 = { class: "slide-div" }
const _hoisted_20 = { class: "slide-div" }
const _hoisted_21 = { class: "slide-div" }
const _hoisted_22 = { class: "slide-div" }
const _hoisted_23 = { class: "d-flex flex-column align-center justify-center mt-5" }
const _hoisted_24 = { class: "more-options" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-center align-center" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Mais opções para você e sua Instituição!")
], -1))
const _hoisted_26 = { class: "grid-info" }
const _hoisted_27 = { class: "mt-5 mb-12" }
const _hoisted_28 = { class: "d-flex flex-column justify-center align-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-h6" }, " Além disso, disponibilizamos a Assinatura Digital ", -1))
const _hoisted_30 = { class: "d-flex flex-row" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Para segurança, facilidade e rapidez nos processos, disponibilizamos a assinatura com reconhecimento por QRCode, para assegurar a originalidade dos documentos gerados! ")
const _hoisted_32 = { class: "d-flex justify-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-column align-center justify-center mb-5",
  style: {"margin-top":"20%"}
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "w-75 font-weight-medium" }, "SIPPAG onde estiver e quando precisar."),
  /*#__PURE__*/_createElementVNode("div", { class: "pt-5 w-75" }, " Os principais módulos do SIPPAG já estão disponíveis para acesso via smartphone! ")
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "d-flex flex-column align-center justify-center mt-3" }
const _hoisted_36 = { class: "more-options" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-center align-center" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Ainda mais opções!")
], -1))
const _hoisted_38 = { class: "grid-info" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mb-1" }, "Quer saber mais ?", -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Fale com a gente")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_CardProductsinitial = _resolveComponent("CardProductsinitial")!
  const _component_CardProducts = _resolveComponent("CardProducts")!
  const _component_CardProductsMultiple = _resolveComponent("CardProductsMultiple")!
  const _component_InfoModulo = _resolveComponent("InfoModulo")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_v_sheet, { class: "d-flex justify-center align-center flex-column px-6 pt-6 pb-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "text-center pt-5 bg-transparent text-white",
            "max-width": "900",
            flat: ""
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_CardProductsinitial, {
                content: "Economia de tempo e rapidez nos processos",
                icon: "mdi-currency-usd"
              }),
              _createVNode(_component_CardProductsinitial, {
                icon: "mdi-finance",
                content: "Maior eficiência na execução de tarefas"
              }),
              _createVNode(_component_CardProductsinitial, {
                icon: "mdi-library",
                content: "Aumento da qualidade e quantidade de serviços"
              }),
              _createVNode(_component_CardProductsinitial, {
                icon: "mdi-file-multiple",
                content: "Padronização de documentos"
              }),
              _createVNode(_component_CardProductsinitial, {
                icon: "mdi-auto-fix",
                content: "Sistema personalizado para cada instituição"
              })
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_CardProducts, {
              icon: "mdi-calculator",
              title: "Cálculos de Progressão",
              content: [
                    'Por Mérito Profissional',
                    'Por Capacitação',
                    'Incentivo à Qualificação (IQ)',
                    'Funcional',
                    'Retribuição por Titulação (RT)',
                    'Promoção',
                    'Aceleração de Promoção',
                    'RSC',
                    ]
            }, null, 8, ["content"]),
            _createVNode(_component_CardProducts, {
              icon: "mdi-wallet-plus",
              title: "Cálculos de Adicionais",
              content: [
                    'Insalubridade',
                    'Gratificação Raio X',
                    'Periculosidade',
                    'Ionizante',
                    'Horas extras',
                    'Horas extras',
                    'Adicional Noturno'
                    ]
            }),
            _createVNode(_component_CardProducts, {
              icon: "mdi-star-circle",
              title: "Outros Cálculos",
              content: [
                    'GECC',
                    'Férias',
                    'Gratificação Natalina',
                    'Exercícios anteriores',
                    'Alteração de carga horária',
                    'Anuênio',
                    'Substituição/chefia (CD – FG)',
                    'Desligamento',
                    'Desconto do mês anterior',
                    'Cálculo informado'
                    ]
            }, null, 8, ["content"])
          ])
        ]),
        _createElementVNode("section", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_CardProductsMultiple, {
              icon: "mdi-file-compare",
              title: "Modelos de Portarias",
              footer: "E mais de 200 outros modelos disponíveis e customizáveis!",
              content: [
                    'Progressão Funcional',
                    'Progressão por Mérito',
                    'Progressão por Capacitação',
                    'Retribuição por Titulação',
                    'Incentivo a Qualificação',
                    'Progressão por Aceleração',
                    'Progressão por Promoção',
                    'Remoção',
                    'Concessão de Adicional',
                    ],
              content2: [
                    'Exclusão de Adicional',
                    'Afastamento Integral',
                    'Prorrogação de Afastamento',
                    'Alteração de Titulação',
                    'Mudança de Carga Horária',
                    'Alteração de carga horária',
                    'Afastamento Parcial',
                    'Licença Casamento',
                    'Licença Gestante',
                    ],
              content3: [
                    'Licença Paternidade',
                    'Nojo',
                    'Doação de Sangue',
                    'Recadastramento Eleitoral',
                    'Serviço Obrigatório',
                    'Participação Eleição',
                    'Retificação',
                    'Tornar sem Efeito',
                    'Revogar',
                    ]
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    alt: "SEI!",
                    class: _normalizeClass(["mb-1 mx-5", _ctx.changeColor(this.$vuetify.theme.name)]),
                    src: _imports_1,
                    style: {"width":"53px","height":"50px"}
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("img", {
                    alt: "SIAPE",
                    class: _normalizeClass(["mb-1 mx-5", _ctx.changeColor(this.$vuetify.theme.name)]),
                    src: _imports_2,
                    style: {"width":"95px","height":"42px"}
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("img", {
                    alt: "SIPEC",
                    class: _normalizeClass(["mt-2 mx-5", _ctx.changeColor(this.$vuetify.theme.name)]),
                    src: _imports_3,
                    style: {"width":"110px","height":"50px"}
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("img", {
                    alt: "SUAPE",
                    class: _normalizeClass(["mt-3 mx-5", _ctx.changeColor(this.$vuetify.theme.name)]),
                    src: _imports_4,
                    style: {"width":"100px","height":"35px"}
                  }, null, 2)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_InfoModulo, {
            title: "Módulo Portaria",
            content: "Permite a criação e diversos assuntos de\nportarias com textos pré-cadastrados, tanto de\nmodelos que envolvam apenas um servidor quanto\nmodelos de comissões. Além disso, é um grande\nfacilitador para o cálculo de processos no SIPPAG, pois\nenvia os dados necessários para realizar os cálculos\nautomaticamente."
          }),
          _createVNode(_component_InfoModulo, {
            title: "Relatório Gerenciais",
            content: "O SIPPAG possui uma gama de relatórios gerenciais,\ncomo de uso do sistema, gastos com servidores por\nfolha e relatórios de rubricas enviadas pelo sistema,\ndentre outros que a gestão possa necessitar."
          }),
          _createVNode(_component_InfoModulo, {
            title: "Módulo Acompanhamento\nde Comissões",
            content: "A fim de acompanhar prazos e processos, esse módulo\npermite o cadastro de dados fundamentais para o\nacompanhamento de comissões. Próximo ao fim dos\nprazos, um e-mail é disparado para os responsáveis do\nprocesso para verificar o andamento do mesmo."
          }),
          _createVNode(_component_InfoModulo, {
            title: "Módulo Gerenciamento\nde Riscos",
            content: " Disponibilizamos esse\nmódulo para que a matriz de riscos seja criada de\nacordo com grupos de exposição e os fatores de riscos\nrelacionados a cada um. Além disso, também é possível\nfazer o acompanhamento dos métodos preventivos,\npromovendo o bem-estar dos servidores expostos a\ncertos riscos, de acordo com a sua localização."
          }),
          _createVNode(_component_InfoModulo, {
            title: " Módulo Termo de Reconhecimento\nde Dívidas",
            content: " Geração do documento padronizado, enviado para o servidor interessado, referente ao pagamento de exercícios anteriores, logo após realizar cálculos dessa natureza dentro dos nossos sistemas."
          }),
          _createVNode(_component_InfoModulo, {
            title: "Módulo Auxílio Saúde",
            content: " Para controle interno, disponibilizamos um formulário\nde cadastro dos servidores que recebem auxílio saúde,\nconstando o histórico individual, com o tipo de plano\nde saúde, situação e status."
          }),
          _createVNode(_component_InfoModulo, {
            title: " Módulo Nota Técnica",
            content: " Geração do documento padronizado, associando automaticamente, o assunto da Nota Técnica ao cálculo realizado nos nossos sistemas.\n"
          }),
          _createVNode(_component_InfoModulo, {
            title: " Módulo Licença Capacitação",
            content: " Esse módulo, seguindo o regimento legal, aloca os\nservidores para tirarem suas licenças de capacitação\nsem permitir que mais de 5% dos servidores estejam\nafastados ao mesmo tempo da instituição, colocando a\ndata mais próxima para que possa cumprir o seu\nafastamento sem descumprir a regra. "
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_v_icon, {
            icon: "mdi-qrcode-scan",
            class: "mr-2 mt-1",
            color: "icon",
            style: {"font-size":"54px"}
          }),
          _createVNode(_component_v_sheet, {
            class: "bg-transparent",
            "max-width": "500"
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_v_sheet, { class: "w-100 bg-secondary-card" }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_32, [
            _createElementVNode("div", {
              style: {"margin-top":"-2%"},
              class: _normalizeClass(["mobileBack h-100 d-flex justify-center align-center", _ctx.useDisplay().xs.value ? 'w-75' : 'w-50'])
            }, _hoisted_34, 2)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_InfoModulo, {
            title: "Publicização de Informações\n",
            content: "Seguindo o princípio da publicidade, o SIPPAG disponibiliza o site\n            institucional com as portarias geradas pelo sistema e dados gerais de servidores mês a mês,\n            permitindo, assim, o acesso do público externo a essas informações\n"
          }),
          _createVNode(_component_InfoModulo, {
            title: " Boletim de Serviço\n",
            content: "A publicidade de portarias confeccionadas, agrupadas por períodos de um mês.\n"
          }),
          _createVNode(_component_InfoModulo, {
            title: "Emissão de declaração",
            content: "Permite a geração de declaração de vínculo ou não com a Instituição, sem necessidade de login ou solicitações à Gestão de Pessoas.\n"
          }),
          _createVNode(_component_InfoModulo, {
            title: "Módulo Portarias\n",
            content: "Facilitando o procedimento para acesso em qualquer lugar, o módulo de portarias também é disponibilizado no sistema em web, permitindo a criação de portarias e a assinatura das mesmas no site da Instituição cliente, por meio de login autorizado."
          }),
          _createVNode(_component_InfoModulo, {
            title: "Módulo de Solicitações",
            content: "Os servidores podem solicitar pequenas modificações\nna sua lotação, exercícios e outros, através do seu\nperfil do SIPPAG Web, esta tela registra e informa quais\nforam as suas solicitações e se foram aprovadas ou\nreprovadas."
          }),
          _createVNode(_component_InfoModulo, {
            title: "Levantamento de Necessidades do Plano de Desenvolvimento de Pessoas (PDP)",
            content: "No levantamento do PDP o servidor pode fazer a solicitação de um pedido de capacitação, preenchendo todos os campos, onde serão definidos suas preferências e objetivos. Permite também que a gestão avalie os pedidos, podendo retornar ao servidor seu pedido, para a edição de informações preenchidas de forma equivocada."
          }),
          _createVNode(_component_InfoModulo, {
            title: "Módulo Concurso",
            content: "Permite que o servidor preencha os documentos necessários para sua nomeação na Instituição, como o exame de investidura e resumo funcional, dentre outros. Além disso, também possui o recurso de assinatura digital."
          })
        ])
      ])
    ]),
    _createVNode(_component_v_sheet, { class: "d-flex flex-column justify-center align-center pa-5 mb-1 text-white" }, {
      default: _withCtx(() => [
        _hoisted_39,
        _createVNode(_component_v_btn, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToContact())),
          variant: "tonal"
        }, {
          default: _withCtx(() => [
            _hoisted_40
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}